import { useMemo } from "react";
import Token from "src/util/Token";
import { COMPANY_TYPE } from "src/util/enums";

/**
 * True only for the ROOT owner of the Grand Parent company — the unlimited
 * super admin. Mirrors step 2 of requireSuperAdminFeature on the API, which
 * lets USER_TYPE.ROOT through before any cms_access lookup happens.
 *
 * Every other GP user is a limited super admin whose capabilities come from
 * their role, so gate those on the specific feature instead. Gating them on a
 * different feature (Finance, say) makes the UI offer actions the API rejects.
 */
export const useIsRootSuperAdmin = () => {
  return useMemo(() => {
    const parsed = Token.parsedToken();
    return (
      parsed.success &&
      parsed.data?.companyType === COMPANY_TYPE.GRAND_PARENT &&
      parsed.data?.userType === "ROOT"
    );
  }, []);
};

export default useIsRootSuperAdmin;
